import { useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import SEO from "@/components/SEO";
import Breadcrumb from "@/components/Breadcrumb";

export default function ContactPage() {
  const [form, setForm] = useState({ name: "", email: "", subject: "", message: "" });
  const [loading, setLoading] = useState(false);

  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await api.contact(form);
      toast.success(res.message);
      setForm({ name: "", email: "", subject: "", message: "" });
    } catch { toast.error("Something went wrong."); }
    finally { setLoading(false); }
  };

  return (
    <>
      <SEO title="Contact" description="Contact Finance Topia — send us a story tip, correction, or reader feedback." url="/contact" />
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <Breadcrumb items={[{ label: "Home", to: "/" }, { label: "Contact" }]} />
        <header className="border-b-2 border-foreground pb-6 mt-4">
          <div className="overline">Contact</div>
          <h1 className="font-display font-black text-5xl md:text-6xl mt-2 tracking-tight">Say hello.</h1>
          <p className="mt-3 text-foreground/70 max-w-xl">
            Story tips, corrections, partnership inquiries, or reader feedback — send us a note. We reply within two business days.
          </p>
        </header>
        <form onSubmit={submit} data-testid="contact-form" className="mt-10 grid gap-5">
          <div className="grid gap-5 md:grid-cols-2">
            <div>
              <label className="overline block mb-2">Your name</label>
              <input data-testid="contact-name" required value={form.name} onChange={set("name")} className="w-full h-12 px-4 border border-foreground/25 focus:border-foreground bg-transparent outline-none" />
            </div>
            <div>
              <label className="overline block mb-2">Email</label>
              <input data-testid="contact-email" required type="email" value={form.email} onChange={set("email")} className="w-full h-12 px-4 border border-foreground/25 focus:border-foreground bg-transparent outline-none" />
            </div>
          </div>
          <div>
            <label className="overline block mb-2">Subject</label>
            <input data-testid="contact-subject" required value={form.subject} onChange={set("subject")} className="w-full h-12 px-4 border border-foreground/25 focus:border-foreground bg-transparent outline-none" />
          </div>
          <div>
            <label className="overline block mb-2">Message</label>
            <textarea data-testid="contact-message" required rows={6} value={form.message} onChange={set("message")} className="w-full p-4 border border-foreground/25 focus:border-foreground bg-transparent outline-none resize-y" />
          </div>
          <button data-testid="contact-submit" disabled={loading} className="justify-self-start px-6 h-12 bg-foreground text-background font-semibold hover:bg-primary transition-colors duration-200 disabled:opacity-60">
            {loading ? "Sending…" : "Send message"}
          </button>
        </form>
      </div>
    </>
  );
}
